import React, { useState } from "react";
import { Transition } from 'react-transition-group';
import WPLink from "../wpLink";
import FixedImage from "../fixedImage";
import { Link } from "gatsby";

import * as styleSheet from "./index.module.scss"



const MobileNav = ({mainNavigationSettings, menuIcon, closeIcon, services, arrowBlue, locations, dentists, showMobileCTA = true }) => {
	const {
		showLocationsInMenu,
		showServicesInMenu,
		showTeamInMenu,
		teamMenuTitle,
		servicesMenuTitle,
		navCta,
		links,
		mobileNavLinks,
		locationsMenuTitle,
		mobileNavigationLogo
	} = mainNavigationSettings;

	const [ navOpen, setNavOpen ] = useState(false);
	const [ servicesOpen, setServicesOpen ] = useState(false);
	const [ locationsOpen, setLocationsOpen ] = useState(false);
	const [ teamOpen, setTeamOpen ] = useState(false);

	const toggleNav = () => {
		const toggled = !navOpen;
		setNavOpen(toggled);
	};

	const closeNav = () => {
		setNavOpen(false);
	};

	const toggleServices = () => {
		const toggled = !servicesOpen;
		setServicesOpen(toggled);
	};

	const toggleLocations = () => {
		const toggled = !locationsOpen;
		setLocationsOpen(toggled);
	};

	const toggleTeam = () => {
		const toggled = !teamOpen;
		setTeamOpen(toggled);
	};

	const containerTransitionStyles = {
		entering: { 
			opacity: 0,
		},
		entered:  { 
			opacity: 1,
		},
		exiting:  { 
			opacity: 0,
		},
		exited:  { 
			opacity: 0,
		},
 	};

	 const shroudTransitionStyles = {
		entering: { 
			opacity: 0,
		},
		entered:  { 
			opacity: 0.3,
		},
		exiting:  { 
			opacity: 0,
		},
		exited:  { 
			opacity: 0,
		},
 	};

	 const accordionTransitionStyles = {
		entering: { 
			opacity: "0",
			margin: "0 0 0px 0",
			maxHeight: "0",
		},
		entered:  { 
			opacity: "1",
			margin: "0 0 20px 0",
			maxHeight: "100px",
		},
		exiting:  { 
			opacity: "0",
			margin: "0 0 0px 0",
			maxHeight: "0",
		},
		exited:  { 
			opacity: "0",
			margin: "0 0 0px 0",
			maxHeight: "0",
		},
 	};

  	return (
		<nav className={styleSheet.mobilenav} role="navigation">
			<Transition in={navOpen} timeout={250} mountOnEnter unmountOnExit>
				{(state) => (
					<>
						<div role="button" aria-label="close mobile menu" className={styleSheet.shroud} style={{...shroudTransitionStyles[state]}} onClick={() => { closeNav(); }} onKeyDown={(event) => { if (event.keycode === 13){ closeNav(); }}} tabIndex={0}></div>
						<div className={styleSheet.top} style={{...containerTransitionStyles[state]}}>
							<div className={styleSheet.logosection}>
								<Link to="/" className={styleSheet.logolink}>
									{ mobileNavigationLogo && <FixedImage image={mobileNavigationLogo} className={styleSheet.logo} /> }
								</Link>
							</div>
							<div className={styleSheet.middle}>
								{
									showServicesInMenu && (
										<>
											<button className={servicesOpen ? styleSheet.navlisttoggleactive : styleSheet.navlisttoggle} onClick={()=>{ toggleServices(); }}>{servicesMenuTitle ? servicesMenuTitle : "Services" }</button>
											<Transition in={servicesOpen} timeout={250} mountOnEnter unmountOnExit>
												{(state) => (
													<ul className={styleSheet.navlist}>
														{services && services.map( (service, index) => {
															return (
																<li key={`servicelink-${service.id}`} className={styleSheet.navlistitem} style={{...accordionTransitionStyles[state]}}>
																	<FixedImage passedClass={styleSheet.icon} image={arrowBlue} />
																	<Link to={service.link} className={styleSheet.link}  dangerouslySetInnerHTML={{__html: service.title}}></Link>
																</li>
															)
														})}
													</ul>
												)}
											</Transition>
										</>
									)
								}
								{
									showLocationsInMenu && <Link to={'/locations'} className={styleSheet.linkstyles}>Locations</Link>
								}
								{
									showTeamInMenu && (
										<>
											<button className={teamOpen ? styleSheet.navlisttoggleactive : styleSheet.navlisttoggle} onClick={()=>{ toggleTeam(); }}>{teamMenuTitle ? teamMenuTitle : "Our Team" }</button>
											<Transition in={teamOpen} timeout={250} mountOnEnter unmountOnExit>
												{(state) => (
													<ul className={styleSheet.navlist}>
														{dentists && dentists.map( (dentist, index) => {
															return (
																<li key={`dentistlink-${dentist.id}`} className={styleSheet.navlistitem} style={{...accordionTransitionStyles[state]}}>
																	<FixedImage passedClass={styleSheet.icon} image={arrowBlue} />
																	<Link to={dentist.link} className={styleSheet.link}  dangerouslySetInnerHTML={{__html: dentist.title}}></Link>
																</li>
															)
														})}
													</ul>
												)}
											</Transition>
										</>
									)
								}
								{
									links && links.map( (link, index) => {
										return <WPLink key={`extralink-${index}`} link={link.link} passedClass={styleSheet.linkstyles} />;
									})
								}
							</div>
							{
								mobileNavLinks && (
									<div className={styleSheet.secondarylinks}>
										<ul className={styleSheet.navlist}>
											{mobileNavLinks.map( (link, index) => {
												return (
													<li key={`secondlink-${index}`} className={styleSheet.navlistitem}>
														<WPLink link={link.mobileLinkItem} passedClass={styleSheet.link} />
													</li>
												)
											})}
										</ul>				
									</div>
								)
							}
						</div>
					</>
				)}
			</Transition>
			<div className={showMobileCTA ? styleSheet.bottom : styleSheet.bottomnocta}>
				{ showMobileCTA && <WPLink link={navCta} passedClass={styleSheet.cta} /> }
				<button className={styleSheet.togglemenu} onClick={()=>{toggleNav();}}>{ navOpen ? "Close" : "Menu"}{navOpen ? <FixedImage image={closeIcon} passedClass={styleSheet.close} /> : <FixedImage image={menuIcon} passedClass={styleSheet.menu} /> }</button>
			</div>
		</nav>
	);
}

export default MobileNav;
